import React from "react"
import { CustomGrid, Flex, Typography } from "@kohler-dsm-library/kohler-core"
import Style from "@/components/GlobalVisualSearch/globalvisualsearch.module.scss"
import useViewport from "@/hooks/useViewport"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/GlobalVisualSearch/localization"
import { productCategories } from "@/components/GlobalVisualSearch/constant"
import { addAdobeDataLayerGlobalVisualSearch } from "@/components/GlobalVisualSearch/analytics"

const CategorySection = props => {
  const { setOpenCam, setSection, setCategory, setIShowQr } = props || {}
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)
  const { isSmallScreen } = useViewport()
  const { textCommingSoon = "" } = staticText
  const getCategoryTranslations = textKey => {
    const translatedText = staticText[textKey]
    return translatedText
  }
  const handleCategorySelection = (e, item) => {
    if (item.isComingSoon) return
    if (item.value === "serviceParts") {
      setSection("subCategory")
      return
    }
    setCategory(item.value)
    if (isSmallScreen) {
      setOpenCam(true)
      setSection("camera")
    } else {
      setSection("upload")
    }
    addAdobeDataLayerGlobalVisualSearch({
      event: "category_selection",
      category: item.value,
    })
  }

  return (
    <CustomGrid className={Style.ProductGrid}>
      {productCategories.map((item, index) => (
        <Flex
          direction="column"
          justify="center"
          align="start"
          key={index}
          className={Style.ProductItem}
          onClick={e => handleCategorySelection(e, item)}
        >
          {!item.isComingSoon ? (
            <img src={item.image?.src} alt={item.name} />
          ) : (
            <Flex
              justify="center"
              align="center"
              className={Style.comingSoonCard}
              onClick={() => {
                setCategory(item.value)
                setSection("comingSoon")
                setIShowQr(false)
              }}
            >
              <Typography size={"tag-s"}>{textCommingSoon}</Typography>
            </Flex>
          )}
          <Typography size={"label-regular-m"}>
            {getCategoryTranslations(item.name)}
          </Typography>
        </Flex>
      ))}
    </CustomGrid>
  )
}

export default CategorySection
